const keys = {
  NACIONAL: {
    key: 'NACIONAL',
    description: 'Nacional',
  },
  EXTERIOR: {
    key: 'EXTERIOR',
    description: 'Internacional',
  },
};

const values = Object.keys(keys)
  .map(key => keys[key]);

export default {
  keys,
  values,
};
